/**
 * @generated SignedSource<<c45a39203c335f9a555da7f29ec2b181>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterCaratWeight_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuCaratWeight_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuFilterCaratWeight_itemSearch";
};
export type SbRespRefineMenuFilterCaratWeight_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuFilterCaratWeight_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterCaratWeight_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e1a176908cb88e74c5bfbd6093c521da";

export default node;
